// Use the same rules for navigation and direct URL access. Permission names match backend guards.
export const TENANT_ROUTES = [
  { path: "/admindashboard/client-enrollments", permission: "client.read", feature: "CLIENTS" },
  {
    "path": "/admindashboard",
    "permission": null,
    "feature": null
  },
  {
    "path": "/admindashboard/profile",
    "permission": null,
    "feature": null
  },
  {
    "path": "/admindashboard/notifications",
    "permission": null,
    "feature": "NOTIFICATIONS"
  },
  {
    "path": "/admindashboard/analytics",
    "permission": "analytics.view",
    "feature": "ANALYTICS"
  },
  {
    "path": "/admindashboard/advertising",
    "permission": "advertising.read",
    "feature": "ADVERTISING"
  },
  {
    "path": "/admindashboard/products",
    "permission": "product.read",
    "feature": "PRODUCTS"
  },
  {
    "path": "/admindashboard/products/search",
    "permission": "marketplace.read",
    "feature": "MARKETPLACE"
  },
  {
    "path": "/admindashboard/products/incomingreferrals",
    "permission": "productreferral.view",
    "feature": "PRODUCTREFERRALS"
  },
  {
    "path": "/admindashboard/products/referrals",
    "permission": "productreferral.view",
    "feature": "PRODUCTREFERRALS"
  },
  {
    "path": "/admindashboard/events",
    "permission": "event.read",
    "feature": "EVENTS"
  },
  {
    "path": "/admindashboard/franchise",
    "permission": "franchise.read",
    "feature": "FRANCHISE"
  },
  {
    "path": "/admindashboard/clients",
    "permission": "client.read",
    "feature": "CLIENTS"
  },
  {
    "path": "/admindashboard/leads",
    "permission": "lead.read",
    "feature": "LEADS"
  },
  {
    "path": "/admindashboard/registrations",
    "permission": "registration.read",
    "feature": "REGISTRATIONS"
  },
  {
    "path": "/admindashboard/appointments",
    "permission": "appointment.read",
    "feature": "APPOINTMENTS"
  },
  {
    "path": "/admindashboard/meetings",
    "permission": "meeting.read",
    "feature": "MEETINGS"
  },
  {
    "path": "/admindashboard/calls",
    "permission": "calllog.read",
    "feature": "CALLS"
  },
  {
    "path": "/admindashboard/staff",
    "permission": "user.read",
    "feature": "STAFF"
  },
  {
    "path": "/admindashboard/departments",
    "permission": "department.read",
    "feature": "DEPARTMENTS"
  },
  {
    "path": "/admindashboard/positions",
    "permission": "position.read",
    "feature": "POSITIONS"
  },
  {
    "path": "/admindashboard/roles",
    "permission": "role.read",
    "feature": "ROLE"
  },
  {
    "path": "/admindashboard/tasks",
    "permission": "task.read",
    "feature": "TASKS"
  },
  {
    "path": "/admindashboard/my-tasks",
    "permission": "task.read",
    "feature": "TASKS"
  },
  {
    "path": "/admindashboard/staffattendance",
    "permission": "attendance.read",
    "feature": "ATTENDANCE"
  },
  {
    "path": "/admindashboard/website/builder",
    "permission": "website.manage",
    "feature": "WEBSITE"
  },
  {
    "path": "/admindashboard/website/pages",
    "permission": "website.read",
    "feature": "WEBSITE"
  },
  {
    "path": "/admindashboard/website/menus",
    "permission": "website.read",
    "feature": "WEBSITE"
  },
  {
    "path": "/admindashboard/website/forms",
    "permission": "website.read",
    "feature": "WEBSITE"
  },
  {
    "path": "/admindashboard/website/content",
    "permission": "website.read",
    "feature": "WEBSITE"
  },
  {
    "path": "/admindashboard/website/assets",
    "permission": "website.read",
    "feature": "WEBSITE"
  },
  {
    "path": "/admindashboard/website/settings",
    "permission": "website.read",
    "feature": "WEBSITE"
  },
  {
    "path": "/admindashboard/students",
    "permission": "student.read",
    "feature": "STUDENTS"
  },
  {
    "path": "/admindashboard/students/groups",
    "permission": "studentGroup.read",
    "feature": "STUDENT_GROUPS"
  },
  {
    "path": "/admindashboard/onlineclass",
    "permission": "online_class:read",
    "feature": "ONLINE_CLASSES"
  },
  {
    "path": "/admindashboard/attendance",
    "permission": "online_class:read",
    "feature": "CLASSATTENDANCE"
  },
  {
    "path": "/admindashboard/courses/:id",
    "permission": "course.read",
    "feature": "COURSES"
  },
  {
    "path": "/admindashboard/courses",
    "permission": "course.read",
    "feature": "COURSES"
  },
  {
    "path": "/admindashboard/assignments",
    "permission": "assignment.read",
    "feature": "ASSIGNMENTS"
  },
  {
    "path": "/admindashboard/certificates",
    "permission": "certificate:read",
    "feature": "CERTIFICATES"
  },
  {
    "path": "/admindashboard/partners",
    "permission": "partner.read",
    "feature": "PARTNERS"
  },
  {
    "path": "/admindashboard/partners/commissions",
    "permission": "partner.manage_commissions",
    "feature": "COMMISSIONS"
  },
  {
    "path": "/admindashboard/invoices",
    "permission": "invoice.read",
    "feature": "INVOICES"
  },
  {
    "path": "/admindashboard/payments",
    "permission": "payment.read",
    "feature": "PAYMENTS"
  },
  {
    "path": "/admindashboard/accounts/expenses",
    "permission": "expense.read",
    "feature": "EXPENSES"
  },
  {
    "path": "/admindashboard/masters/branches",
    "permission": "master.branch.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/stores",
    "permission": "master.store.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/suppliers",
    "permission": "master.supplier.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/products",
    "permission": "master_products.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/products/add",
    "permission": "master_products.create",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/brands",
    "permission": "master.brand.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/categories",
    "permission": "master.category.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/subcategories",
    "permission": "master.subcategory.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/colors",
    "permission": "master.color.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/seasons",
    "permission": "master.season.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/sizegroup",
    "permission": "master.size_group.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/sizes",
    "permission": "master.size.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/units",
    "permission": "master.unit.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/hsn-gst",
    "permission": "master.tax.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/promotions",
    "permission": "master.promotion.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/inventory/adjustment",
    "permission": "inventory.adjustment.read",
    "feature": "INVENTORY"
  },
  {
    "path": "/admindashboard/inventory/ledger",
    "permission": "inventory.ledger.read",
    "feature": "INVENTORY"
  },
  {
    "path": "/admindashboard/inventory/transfers",
    "permission": "inventory.transfer.read",
    "feature": "INVENTORY"
  },
  {
    "path": "/admindashboard/inventory/transfers/create",
    "permission": "inventory.transfer.create",
    "feature": "INVENTORY"
  },
  {
    "path": "/admindashboard/inventory/count",
    "permission": "inventory.count.read",
    "feature": "INVENTORY"
  },
  {
    "path": "/admindashboard/inventory/low-stock",
    "permission": "inventory.low_stock.read",
    "feature": "INVENTORY"
  },
  {
    "path": "/admindashboard/inventory/valuation",
    "permission": "inventory.valuation.read",
    "feature": "INVENTORY"
  },
  {
    "path": "/admindashboard/purchases/orders",
    "permission": "purchase.order.read",
    "feature": "PURCHASES"
  },
  {
    "path": "/admindashboard/purchases/create",
    "permission": "purchase.order.create",
    "feature": "PURCHASES"
  },
  {
    "path": "/admindashboard/purchases/grn",
    "permission": "purchase.grn.read",
    "feature": "PURCHASES"
  },
  {
    "path": "/admindashboard/purchases/grn/create",
    "permission": "purchase.grn.create",
    "feature": "PURCHASES"
  },
  {
    "path": "/admindashboard/purchases/returns",
    "permission": "purchase.return.read",
    "feature": "PURCHASES"
  },
  {
    "path": "/admindashboard/purchases/returns/create",
    "permission": "purchase.return.create",
    "feature": "PURCHASES"
  },
  {
    "path": "/admindashboard/sales/ecommerce-orders",
    "permission": "ecommerce_orders.read",
    "feature": "SALES"
  },
  {
    "path": "/admindashboard/sales/customers",
    "permission": "customers.read",
    "feature": "customers"
  },
  {
    "path": "/admindashboard/sales/orders/list",
    "permission": "sales_orders.read",
    "feature": "SALES"
  },
  {
    "path": "/admindashboard/sales/orders/create",
    "permission": "sales_orders.create",
    "feature": "SALES"
  },
  {
    "path": "/admindashboard/delivery/challan/list",
    "permission": "delivery_challans.read",
    "feature": "DELIVERY"
  },
  {
    "path": "/admindashboard/delivery/challan/create",
    "permission": "delivery_challans.create",
    "feature": "DELIVERY"
  },
  {
    "path": "/admindashboard/sales/invoice/list",
    "permission": "sales_invoices.read",
    "feature": "SALES"
  },
  {
    "path": "/admindashboard/sales/payment",
    "permission": "sales_payments.create",
    "feature": "SALES"
  },
  {
    "path": "/admindashboard/sales/returns",
    "permission": "sales_returns.read",
    "feature": "SALES"
  },
  {
    "path": "/admindashboard/sales/returns/create",
    "permission": "sales_returns.create",
    "feature": "SALES"
  },
  {
    "path": "/admindashboard/sales/credit-notes",
    "permission": "sales_credit_notes.read",
    "feature": "SALES"
  },
  {
    "path": "/admindashboard/hrms/employees",
    "permission": "employee.read",
    "feature": "EMPLOYEES"
  },
  {
    "path": "/admindashboard/hrms/employees/add",
    "permission": "employee.create",
    "feature": "EMPLOYEES"
  },
  {
    "path": "/admindashboard/hrms/attendance",
    "permission": "hrms_attendance.read",
    "feature": "HRMS_ATTENDANCE"
  },
  {
    "path": "/admindashboard/hrms/attendance/daily",
    "permission": "hrms_attendance.daily.read",
    "feature": "HRMS_ATTENDANCE"
  },
  {
    "path": "/admindashboard/hrms/attendance/monthly",
    "permission": "hrms_attendance.monthly.read",
    "feature": "HRMS_ATTENDANCE"
  },
  {
    "path": "/admindashboard/hrms/attendance/corrections",
    "permission": "hrms_attendance.correction.read",
    "feature": "HRMS_ATTENDANCE"
  },
  {
    "path": "/admindashboard/hrms/payroll",
    "permission": "payroll.read",
    "feature": "PAYROLL"
  },
  {
    "path": "/admindashboard/hrms/payroll/generate",
    "permission": "payroll.generate",
    "feature": "PAYROLL"
  },
  {
    "path": "/admindashboard/hrms/payroll/off-cycle",
    "permission": "payroll.generate",
    "feature": "PAYROLL"
  },
  {
    "path": "/admindashboard/hrms/payroll/payslips",
    "permission": "payslip.team.read",
    "feature": "PAYROLL"
  },
  {
    "path": "/admindashboard/hrms/leave",
    "permission": "leave.request.read",
    "feature": "LEAVE"
  },
  {
    "path": "/admindashboard/hrms/leave/apply",
    "permission": "leave.request.create",
    "feature": "LEAVE"
  },
  {
    "path": "/admindashboard/hrms/leave/balance",
    "permission": "leave.balance.read",
    "feature": "LEAVE"
  },
  {
    "path": "/admindashboard/hrms/leave/types",
    "permission": "leave.type.read",
    "feature": "LEAVE"
  },
  {
    "path": "/pos",
    "permission": "pos.view",
    "feature": "POS"
  },
  {
    "path": "/admindashboard/pos/counters",
    "permission": "pos.manage_counters",
    "feature": "POS"
  },
  {
    "path": "/admindashboard/reports/sales",
    "permission": "report.sales.read",
    "feature": "REPORTS"
  },
  {
    "path": "/admindashboard/reports/customsales",
    "permission": "report.custom_sales.read",
    "feature": "REPORTS"
  },
  {
    "path": "/admindashboard/reports/customers",
    "permission": "report.customer.read",
    "feature": "REPORTS"
  },
  {
    "path": "/admindashboard/reports/inventory",
    "permission": "report.inventory.read",
    "feature": "REPORTS"
  },
  {
    "path": "/admindashboard/reports/purchases",
    "permission": "report.purchase.read",
    "feature": "REPORTS"
  },
  {
    "path": "/admindashboard/reports/pos",
    "permission": "report.pos.read",
    "feature": "REPORTS"
  },
  {
    "path": "/admindashboard/reports/finance",
    "permission": "report.finance.read",
    "feature": "REPORTS"
  },
  {
    "path": "/admindashboard/reports/gst",
    "permission": "report.gst.read",
    "feature": "REPORTS"
  },
  {
    "path": "/admindashboard/reports/attendance",
    "permission": "report.attendance.read",
    "feature": "REPORTS"
  },
  {
    "path": "/admindashboard/reports/payroll",
    "permission": "report.payroll.read",
    "feature": "REPORTS"
  },
  {
    "path": "/admindashboard/reports/employee",
    "permission": "report.employee.read",
    "feature": "REPORTS"
  },
  {
    "path": "/admindashboard/events/:id",
    "permission": "event.read",
    "feature": "EVENTS"
  },
  {
    "path": "/admindashboard/events/:id/galleries/:galleryId/design",
    "permission": "event.gallery.manage",
    "feature": "EVENTS"
  },
  {
    "path": "/admindashboard/clients/:clientId/purchase",
    "permission": "clientpurchase.create",
    "feature": "CLIENTS"
  },
  {
    "path": "/admindashboard/clients/:id/profile",
    "permission": "client.read",
    "feature": "CLIENTS"
  },
  {
    "path": "/admindashboard/students/:id/profile",
    "permission": "student.read",
    "feature": "STUDENTS"
  },
  {
    "path": "/admindashboard/students/:studentId/enroll",
    "permission": "studentenroll.create",
    "feature": "STUDENT_ENROLLMENTS"
  },
  {
    "path": "/admindashboard/meetings/:id/room",
    "permission": "meeting.read",
    "feature": "MEETINGS"
  },
  {
    "path": "/admindashboard/leads/new",
    "permission": "lead.create",
    "feature": "LEADS"
  },
  {
    "path": "/admindashboard/leads/form-builder",
    "permission": "lead.update",
    "feature": "LEADS"
  },
  {
    "path": "/admindashboard/onlineclass/create",
    "permission": "online_class:create",
    "feature": "ONLINE_CLASSES"
  },
  {
    "path": "/admindashboard/onlineclass/:id/join",
    "permission": "online_class:read",
    "feature": "ONLINE_CLASSES"
  },
  {
    "path": "/admindashboard/partners/:partnerId/profile",
    "permission": "partner.read",
    "feature": "PARTNERS"
  },
  {
    "path": "/admindashboard/partners/association",
    "permission": "partner.read",
    "feature": "PARTNERS"
  },
  {
    "path": "/admindashboard/associations/:associationId",
    "permission": "marketplace.read",
    "feature": "MARKETPLACE"
  },
  {
    "path": "/admindashboard/marketplace/products/:id",
    "permission": "marketplace.read",
    "feature": "MARKETPLACE"
  },
  {
    "path": "/admindashboard/marketplace/company/:id",
    "permission": "marketplace.read",
    "feature": "MARKETPLACE"
  },
  {
    "path": "/admindashboard/advertising/payment-status",
    "permission": "advertising.read",
    "feature": "ADVERTISING"
  },
  {
    "path": "/admindashboard/website/forms/:id/builder",
    "permission": "website.manage",
    "feature": "WEBSITE"
  },
  {
    "path": "/admindashboard/website/preview/:slug",
    "permission": "website.read",
    "feature": "WEBSITE"
  },
  {
    "path": "/admindashboard/masters/products/:id",
    "permission": "master_products.read",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/masters/products/:id/edit",
    "permission": "master_products.update",
    "feature": "MASTER_DATA"
  },
  {
    "path": "/admindashboard/purchases/:id",
    "permission": "purchase.order.read",
    "feature": "PURCHASES"
  },
  {
    "path": "/admindashboard/purchases/grn/:id",
    "permission": "purchase.grn.read",
    "feature": "PURCHASES"
  },
  {
    "path": "/admindashboard/purchases/returns/:id",
    "permission": "purchase.return.read",
    "feature": "PURCHASES"
  },
  {
    "path": "/admindashboard/sales/customers/:id",
    "permission": "customers.read",
    "feature": "customers"
  },
  {
    "path": "/admindashboard/sales/orders/:id",
    "permission": "sales_orders.read",
    "feature": "SALES"
  },
  {
    "path": "/admindashboard/sales/invoice/:id",
    "permission": "sales_invoices.read",
    "feature": "SALES"
  },
  {
    "path": "/admindashboard/sales/returns/:id",
    "permission": "sales_returns.read",
    "feature": "SALES"
  },
  {
    "path": "/admindashboard/sales/credit-notes/:id",
    "permission": "sales_credit_notes.read",
    "feature": "SALES"
  },
  {
    "path": "/admindashboard/delivery/challan/:id",
    "permission": "delivery_challans.read",
    "feature": "DELIVERY"
  },
  {
    "path": "/admindashboard/hrms/employees/:id",
    "permission": "employee.read",
    "feature": "EMPLOYEES"
  },
  {
    "path": "/admindashboard/hrms/employees/:id/edit",
    "permission": "employee.update",
    "feature": "EMPLOYEES"
  },
  {
    "path": "/admindashboard/hrms/payroll/payslips/:id",
    "permission": "payslip.team.read",
    "feature": "PAYROLL"
  },
  {
    "path": "/admindashboard/hrms/leave/requests/:id",
    "permission": "leave.request.read",
    "feature": "LEAVE"
  },
  {
    "path": "/admindashboard/accounts/profit-loss",
    "permission": null,
    "feature": null,
    "ownerOnly": true
  },
  {
    "path": "/admindashboard/accounts/ledger",
    "permission": null,
    "feature": null,
    "ownerOnly": true
  },
  {
    "path": "/admindashboard/accounts/balance-sheet",
    "permission": null,
    "feature": null,
    "ownerOnly": true
  },
  {
    "path": "/admindashboard/accounts/tax",
    "permission": null,
    "feature": null,
    "ownerOnly": true
  },
  {
    "path": "/admindashboard/accounts/reports",
    "permission": null,
    "feature": null,
    "ownerOnly": true
  },
];
const cleanPath = path => (path || '').split(/[?#]/)[0].replace(/\/+$/, '') || '/';
export const isTenantPath = path => /^\/admindashboard(?:\/|$)/.test(path) || path === '/pos' || /^\/pos\//.test(path) && path !== '/pos/login';
const matches = (pattern, path) => { const a=pattern.split('/'), b=path.split('/'); return a.length===b.length && a.every((segment,index)=>segment.startsWith(':') || segment===b[index]); };
export const getTenantRoute = path => {
 const current=cleanPath(path);
 return TENANT_ROUTES.find(rule=>rule.path===current) || TENANT_ROUTES.find(rule=>matches(rule.path,current)) || null;
};
export const canAccessTenantRoute = (path, {user, permissions=[], features=[]}) => {
 if (!user || (!user.isOwner && user.type !== 'STAFF')) return false;
 const rule=getTenantRoute(path);
 if (!rule) return false;
 if (rule.feature && !features.includes('ALL') && !features.includes(rule.feature)) return false;
 if (user.isOwner) return true;
 if (rule.ownerOnly) return false;
 return !rule.permission || permissions.includes('ALL') || permissions.includes(rule.permission);
};
export const filterTenantSections = (sections, auth) => sections.map(section=>({ ...section,
 items: section.items.flatMap(item=> item.children ? [{...item, children:item.children.filter(child=>canAccessTenantRoute(child.to,auth))}].filter(parent=>parent.children.length) : canAccessTenantRoute(item.to,auth) ? [item] : []),
})).filter(section=>section.items.length);
